import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/views/home')
const News = () => import('@/views/news')
const Investment = () => import('@/views/Investment')
const AboutUs = () => import('@/views/AboutUs')
const ERP = () => import('@/views/erp')
const FBA = () => import('@/views/FBA')
const Plan = () => import('@/views/plan')
const Service = () => import('@/views/service')
const Dedicate = () => import('@/views/dedicate')
const Knowledge = () => import('@/views/knowledge')
const newsDeatils = () => import('@/views/newsDeatils')

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
Vue.use(Router)

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/Investment',
      name: 'Investment',
      component: Investment
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/knowledge',
      name: 'Knowledge',
      component: Knowledge
    },
    {
      path: '/erp',
      name: 'ERP',
      component: ERP
    },
    {
      path: '/FBA',
      name: 'FBA',
      component: FBA
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/dedicate',
      name: 'Dedicate',
      component: Dedicate
    },
    {
      path: '/newsDeatils',
      name: 'newsDeatils',
      component: newsDeatils
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    }
  ]

  const router = new Router({
    mode: 'history',
    routes: routes,

  })
  export default router



// WEBPACK FOOTER //
// ./src/router/index.js